<template>
  <div>
    <app-header></app-header>
    <div class="container top-padding">
      <div class="row">
        <div class="col-md-4 mx-auto">
          <confirmation-form></confirmation-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import header from '../components/layoutComponent/Header'
import confirmationForm from '../components/confirmationForm'
export default {
  components: {
    appHeader: header,
    confirmationForm
  }
}
</script>
<style lang="scss" scoped>
.top-padding {
  padding-top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/pages/PageConfirmationCompte.vue